module.exports = __webpack_public_path__ + "img/Weapon_211.014c3830.png";